import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadablePrivacyNoticePage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadablePrivacyNoticePage;
